import React from 'react';

import { Download } from 'lucide-react'
import { Button, DropdownMenuItem } from 'twyne-new.ui'

import { HeaderSeparator, ReportDatePicker, ReportHeader, ReportHeaderDates, ReportHeaderDesktopActions, ReportHeaderMobileActions, ReportMenuConfigure, ReportMobileMenu, RunButton } from '@/components/reports/header'

function ReportsProgressionHeader({ onChangeDates, dates, onClickExport, sync, isLoading, children }) {
  return <>
    <Title>
      <ReportHeaderDates>
        <ReportDatePicker dates={dates} onChange={onChangeDates} />
      </ReportHeaderDates>
      <HeaderSeparator />
      <ReportHeaderDesktopActions>
        {children}
        <Button size="lg" variant='outline' onClick={onClickExport} >Export</Button>
      </ReportHeaderDesktopActions>
      <ReportHeaderMobileActions>
        <ReportMobileMenu>
          <ReportMenuConfigure />
          <DropdownMenuItem icon={Download} onSelect={onClickExport}>Export</DropdownMenuItem>
        </ReportMobileMenu>
        <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
      </ReportHeaderMobileActions>
    </Title>
  </>
}

const Title = ({ children }) => <>
  <ReportHeader title='Progression Report'>
    {children}
  </ReportHeader>
</>

export default ReportsProgressionHeader;
